<script lang="ts" setup>
const handleClick = () => {
  window.print()
}
</script>

<template>
  <a class="print-button noprint" @click="handleClick">
    <small>
      <FontAwesomeIcon class="icon" icon="print" />
      <span>{{ $t('general.print') }}</span>
    </small>
  </a>
</template>

<style lang="scss" scoped>
.print-button {
  cursor: pointer;
}
</style>
